<template>
    <div class="page-container">
        <div class="page-inner page-left">
            <div class="page-box-title title1">
                作文批阅
            </div>
            <div class="correct-title">包含常规评阅、教学评阅、考试评阅三种评阅方式，均采用三步九法思想进行评阅，各自评阅标准不同。
                <el-popover placement="right-start" trigger="click" width="300">
                    <template #reference>
                        <span style="color:#ef8b25;">了解区别
                            <el-icon>
                                <QuestionFilled />
                            </el-icon>
                        </span>
                    </template>
                    <div class="distinction-box">
                        <div class="distinction-box-title">一、常规评阅</div>
                        <div>
                            常规评阅用于日常作文水平的快速诊断，按对应学段满分制（小学30分、初中50分）进行综合打分并给出等级评定。它侧重从审题、中心、内容、结构、语言等宏观维度整体判断作文质量，不深究细节，适合日常练习和课后作业的整体评估。
                            <!-- <div>日常作文水平快速诊断</div>
                            <div>• 按50分制综合打分，给出等级评定。</div>
                            <div>• 快速判断作文整体质量，适合日常练习、课后作业的整体评估。</div> -->
                        </div>
                        <div class="distinction-box-title">二、考试评阅</div>
                        <div>
                            考试评阅严格对标小、中考场标准，按照官方考试评分细则逐项分项打分，并明确标注各得分点与扣分项。这种方式以量化评分和规则适应为核心，帮助学生提前熟悉考场评分规则，适用于模拟考试和考前冲刺训练。
                            <!-- <div>对标小/中/高考考场标准</div>
                            <div>• 严格按照官方考试评分细则分项打分。</div>
                            <div>• 明确标注扣分项、得分点，提前适配考场规则，用于模拟考试、考前冲刺训练。</div> -->
                        </div>
                        <div class="distinction-box-title">三、教学评阅</div>
                        <div>
                            教学评阅采用逐句精批与针对性教学指导，逐句标注错别字、病句、逻辑漏洞及表达不当之处，并附上具体的修改建议和优化方向。它不以分数为唯一重心，而是侧重过程性辅导，引导学生逐一纠正问题，稳步提升写作能力。
                            <!-- <div>逐句精批+针对性教学指导</div>
                            <div>• 逐句批注，精准指出病句、错别字、逻辑漏洞、表达问题。</div>
                            <div>• 给出详细修改建议与优化方向，侧重教学辅导，帮助学生逐点改正、提升写作能力。</div> -->
                        </div>
                    </div>
                </el-popover>
            </div>
            <div>
                <el-row :gutter="10">
                    <el-col :span="14">
                        <el-input v-model="formData.correctTitle" placeholder="请填写作文标题（必填项）" maxlength="50"></el-input>
                    </el-col>
                    <el-col :span="10">
                        <el-select v-model="formData.correctType" placeholder="请选择评阅方式">
                            <el-option v-for="item in correctType" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row :gutter="10" style="margin-top:10px;">
                    <el-col :span="24">
                        <el-input maxlength="5000" v-model="formData.correctText" type="textarea" :rows="6" placeholder="请输入作文文本，文本拍照二选一即可"></el-input>
                    </el-col>
                </el-row>
                <el-row :gutter="10" style="margin-top:10px;">
                    <el-col :span="24">
                        <el-upload class="upload-box" v-model:file-list="fileList" action="#" :max="5" list-type="picture-card" :http-request="httpRequest" :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
                            <div class="upload-inner">
                                <div>
                                    <el-icon size="24">
                                        <Camera />
                                    </el-icon>
                                </div>
                                <div>作文上传</div>
                            </div>
                        </el-upload>
                    </el-col>
                </el-row>
                <div class="correct-tip">
                    <span class="activeColor">*提示：</span>
                    <span>请把上传单页作文竖着完整的作文图片，确保所有文字都入镜。竖屏的作文图片一次上传一页，可多次上传，最多可上传5页。</span>
                </div>
            </div>
            <div style="margin:20px 0;">
                <!-- || correctImgLoading -->
                <el-button :disabled="aiStart" style="width:100%" color="#ef8b25" class="footer-btn1" @click="submitEvent">AI作文批改</el-button>
            </div>
        </div>
        <div class="page-inner page-right">
            <div class="page-box-title2 title1" v-if="!Object.keys(resultInfo).length">评阅结果</div>
            <div class="page-box-correct" v-if="Object.keys(resultInfo).length">
                <el-tabs v-model="activeName" class="demo-tabs" @tab-change="resultTabChange">
                    <el-tab-pane :label="item.label" :name="item.value" :key="item.value" v-for="item in tabList"></el-tab-pane>
                </el-tabs>
                <div class="page-box-correct-btn">
                    <div @click="transVoice">
                        <el-icon>
                            <Microphone />
                        </el-icon>
                        <span v-if="voiceStatus==2">语音继续</span>
                        <span v-else-if="voiceStatus==1">语音暂停</span>
                        <span v-else-if="voiceStatus==4">语音重播</span>
                        <span v-else>转语音</span>
                    </div>
                    <div @click="exportEvent">
                        导出结果
                    </div>
                </div>
            </div>
            <div class="page-inner-box" v-if="Object.keys(resultInfo).length && activeName!='04'">
                <template v-if="resultInfo.Ⅰ && resultInfo.Ⅰ.length && dataFormat('Ⅰ')">
                    <div class="" v-for="(item,index) in resultInfo.Ⅰ" :key="'Ⅰ'+index" v-html="item">
                    </div>
                </template>
                <template v-if="resultInfo.Ⅱ && resultInfo.Ⅱ.length && dataFormat('Ⅱ')">
                    <div class="" v-for="(item,index) in resultInfo.Ⅱ" :key="'Ⅱ'+index" v-html="item">
                    </div>
                </template>
                <template v-if="resultInfo.Ⅲ && resultInfo.Ⅲ.length && dataFormat('Ⅲ')">
                    <div class="" v-for="(item,index) in resultInfo.Ⅲ" :key="'Ⅲ'+index" v-html="item">
                    </div>
                </template>
                <template v-if="resultInfo.Ⅳ && resultInfo.Ⅳ.length && dataFormat('Ⅳ')">
                    <div class="" v-for="(item,index) in resultInfo.Ⅳ" :key="'Ⅳ'+index" v-html="item">
                    </div>
                </template>
                <template v-if="resultInfo.Ⅴ && resultInfo.Ⅴ.length && dataFormat('Ⅴ')">
                    <div class="" v-for="(item,index) in resultInfo.Ⅴ" :key="'Ⅴ'+index" v-html="item">
                    </div>
                </template>
                <template v-if="resultInfo.Ⅵ && resultInfo.Ⅵ.length && dataFormat('Ⅵ')">
                    <div class="" v-for="(item,index) in resultInfo.Ⅵ" :key="'Ⅵ'+index">
                        <div v-html="item"></div>

                        <div v-html="resultInfo.Ⅶ[index]" v-if="resultInfo.Ⅶ && resultInfo.Ⅶ.length>=resultInfo.Ⅵ.length"></div>
                        <div v-html="resultInfo.Ⅷ[index]" v-if="resultInfo.Ⅷ && resultInfo.Ⅷ.length>=resultInfo.Ⅵ.length"></div>
                    </div>
                </template>
            </div>
            <!-- <div class="page-inner-box" v-if="activeName=='04'">
                                                                                                                                                                                      </div> -->
            <div v-html="aiMessage" class="page-inner-box" v-if="!Object.keys(resultInfo).length && aiMessage && aiMessage!='{}'"></div>
            <div class="page-inner-box empty" v-if="!aiMessage">
                <img src="@/assets/img/empty.png" />
                <div>结果将在此处展示！</div>
            </div>
        </div>

        <el-image-viewer v-if="showPreview" :url-list="previewFileArr" show-progress :initial-index="previewIndex" @close="showPreview = false" />

        <AIpopup v-if="popupShow" :popupShow="popupShow" :cancelShow="false" @cancel="aiCancel"></AIpopup>
    </div>
</template>
<script lang="ts" setup>
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue';
import { compEvalStreamingV2, saveSreamResult, compTeachEvalStreamingV2, compExamEvalStreamingV2, checkAiCall, compPictureStreaming, getVoiceDataOss, html2Pdf } from "@/api/composition.js"
import { uploadImg, delImgApi } from "@/api/common.js"
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import AIpopup from "./components/AIpopup.vue";
import Speech from 'speak-tts'
import { useRoute } from 'vue-router';
import { useStore } from "vuex"
const route = useRoute()
const store = useStore();
const correctType = [
    {
        label: '常规评阅',
        value: '01'
    },
    {
        label: '教学评阅',
        value: '02'
    },
    {
        label: '考试评阅',
        value: '03'
    }
]
const tabArr = [
    {
        label: '评阅结果',
        value: '01'
    },
    {
        label: '总评得分',
        value: '02'
    },
    {
        label: '修改建议',
        value: '03'
    },
    {
        label: '原图批改',
        value: '04'
    },
]
const gradeMap = [
	{
		label:'三年级',
		type:1
	},
	{
		label:'四年级',
		type:1
	},
	{
		label:'五年级',
		type:1
	},
	{
		label:'六年级',	
		type:1
	},
	{
		label:'初一',
		type:2
	},
	{
		label:'初二',
		type:2
	},
	{
		label:'初三',
		type:2
	}
]
const tabList = ref([])
const activeName = ref('')
const formData = ref({
    correctTitle: '',
    correctType: '01',
    correctText: ''
})
const fileList = ref([])
const showPreview = ref(false)
const previewIndex = ref(0)
const previewFileArr = ref([])
let fileArr = []
let controller = null
let aiMessage = ref('')
let resultInfo = ref({})
const aiStart = ref(false)
const formPage = ref('')
const popupShow = ref(false)
const compImg = ref([])
const voiceStatus = ref(0) //1 语音正在播放 2语音暂停 0没有语音 4语音播放完成
const speech = new Speech();
let timeFlag = 0
const romanNumerals = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ", "Ⅶ", "Ⅷ", "Ⅸ", "Ⅹ"];
let resultNum = {}, currentKey = '', regex = new RegExp(`(${romanNumerals.join('|')})|([^${romanNumerals.join('')}]+)`, 'g');
const correctImgShow = ref(false);
const correctImgLoading = ref(false);
const gradeFlag = ref(0)

function aiCancel() {
    aiStart.value = false;
    popupShow.value = false;
    controller && controller.abort()
}
function submitEvent() {
    speech.cancel()
    const { correctTitle, correctType, correctText } = formData.value;
    if (!correctTitle) {
        return ElMessage.warning('请填写作文标题');
    }
    if (!correctText && !fileList.value.length) {
        return ElMessage.warning('请填写作文文本或拍摄作文');
    }

    // if (correctType == '01') {
    //     tabList.value = [
    //         {
    //             label: '评阅结果',
    //             value: '01'
    //         },
    //     ]
    // } else 
    if (['01', '02', '03'].includes(correctType)) {
        tabList.value = [
            {
                label: '总评得分',
                value: '02'
            },
            {
                label: '修改建议',
                value: '03'
            },
        ]
    }
    // if (fileList.value.length) {
    //     tabList.value.push({ label: '原图批改', value: '04' })
    // }
    activeName.value = tabList.value[0].value
    checkAiCall().then(res => {
        if (res.data.result) {
            ElMessageBox.confirm(
                `今日AI调用频繁，已超过${res.data.num}次`,
                '温馨提示',
                {
                    confirmButtonText: '继续用',
                    type: 'warning',
                    showCancelButton: false
                }
            ).then(() => {
                getAi()
            })
        } else {
            getAi()
        }
    })
}

function getAi() {
    const { correctTitle, correctType, correctText } = formData.value;
    const params = {
        grade: sessionStorage.getItem("grade"),
        term: sessionStorage.getItem("term"),
        title: correctTitle,
        text: correctText || '',
        fileIds: fileArr.map(item => {
            return item.fileId
        }).join(','),
    }
    let api;
    switch (formData.value.correctType) {
        case '02':
            api = compTeachEvalStreamingV2
            break;
        case '03':
            api = compExamEvalStreamingV2
            break;
        default:
            api = compEvalStreamingV2
            break;
    }
    aiStart.value = true
    popupShow.value = true
    voiceStatus.value = 0;
    fetchRequest({
        url: api,
        aiParam: params,
        timeFlag: new Date().getTime()
    })
    compImg.value = []
    correctImgShow.value = false;
    correctImgLoading.value = true;
    if (fileArr.length) {
        compPictureStreaming({
            fileIds: fileArr.map(item => {
                return item.fileId
            }).join(','),
        }).then(res => {
            if (res.data) {
                compImg.value = res.data;
            }
            correctImgShow.value = true;
            correctImgLoading.value = false;
        }).catch(() => {
            correctImgShow.value = true;
            correctImgLoading.value = false;
        })
    } else {
        correctImgShow.value = true;
        correctImgLoading.value = false;
    }
}

async function fetchRequest(params) {
    if (timeFlag == params.timeFlag) return;
    timeFlag = params.timeFlag;
    controller = new AbortController()
    const { signal } = controller;
    aiMessage.value = ''
    resultInfo.value = {}
    resultNum = {}
    currentKey = ''
    const response = await fetch(params.url, {
        signal,
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + sessionStorage.getItem("token"),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params.aiParam)
    })
    popupShow.value = false;
    if (!response.ok) {
        try {
            const errorData = await response.join()
            aiStart.value = false
            return ElMessage.warning(errorData.message || '请求失败')
        } catch (error) {
            console.log(error)
            aiStart.value = false
            return ElMessage.warning('请求失败')
        }
    }

    const reader = response.body.getReader()
    const decoder = new TextDecoder('utf-8')
    let done = false;
    let obj = {}
    let str = ''
    while (!done) {
        const {
						done: readerDone,
            value
					} = await reader.read()
        done = readerDone;

        if (value) {
            const chunkText = decoder.decode(value, {
                stream: !done
            })
            const lines = chunkText.split('\n')
            let isMessage = true;
            lines.forEach(line => {
                console.log(line)
                if (line.indexOf('Done') > -1) {
                    isMessage = false;
                    aiStart.value = false
                }
                if (line.indexOf('Error') > -1) {
                    isMessage = false;
                    aiStart.value = false;
                    return ElMessage.warning('AI调用失败，请稍后再试！');
                }
                if (line.indexOf('"500"') > -1) {
                    isMessage = false;
                    aiStart.value = false;
                    let errorMsg = JSON.parse(line).msg;
                    return ElMessage.warning(errorMsg || 'AI调用失败，请稍后再试！');
                }
                if (isMessage && line.indexOf('content') > -1) {
                    let jsonString = '';
                    if (line.startsWith('data:')) {
                        jsonString = line.substring(5).trim();
                    } else {
                        jsonString = line
                    }

                    if (jsonString) {
                        try {
                            const jsonData = JSON.parse(jsonString)
                            if (jsonData ?.node_type == 'End') {
                                console.log('node_is_finish')
                                return
                            }
                            const content = (jsonData ?.content || '');
                            if (content) {
                                str += content
                                const matches = content.match(regex) || [];
                                let resultArr = matches.filter(match => match !== '');
                                resultArr.forEach(info => {
                                    if (romanNumerals.includes(info)) {
                                        if (info in resultNum) {
                                            resultNum[info] = resultNum[info] + 1;
                                            resultInfo.value[info].push('');
                                        } else {
                                            resultNum[info] = 1;
                                            resultInfo.value[info] = [''];
                                        }
                                        currentKey = info;
                                    } else if (currentKey in resultInfo.value) {
                                        if (resultNum[currentKey] == 1) {
                                            resultInfo.value[currentKey][resultNum[
                                                currentKey] - 1] += info.replace(/^\s+/, "").replace(/\n+/g, '<br/>');
                                        } else {
                                            resultInfo.value[currentKey][resultNum[
                                                currentKey] - 1] += info.replace(/\n+/g, '<br/>');
                                        }

                                    }
                                })
                                console.log(resultInfo.value)
                                aiMessage.value = str
                            }
                        } catch (error) {
                            console.log(error)
                            aiStart.value = false
                            return ElMessage.warning('AI调用失败，请稍后再试！');
                        }
                    }
                }
            })
        } else {
            aiStart.value = false;
        }
    }
}

function httpRequest(params) {
    const fileInfo = new FormData()
    fileInfo.append('file', params.file)
    const loading = ElLoading.service({
        lock: true,
        background: 'rgba(0, 0, 0, 0.5)',
    })
    uploadImg(fileInfo).then(res => {
        fileArr.push(res.data)
        previewFileArr.value.push(res.data.fileUrl)
        fileList.value[fileList.value.length - 1]['fileId'] = res.data.fileId;
    }).finally(() => {
        loading.close()
    })
}

function handlePictureCardPreview(file) {
    previewIndex.value = fileArr.findIndex(item => {
        return item.fileId == file.fileId
    })
    showPreview.value = true;
}

function handleRemove(file) {
    if (file.fileId) {
        const index = fileArr.findIndex(item => {
            return item.fileId == file.fileId
        })
        // delImgApi(file.fileId).then(res => {
        ElMessage.success('删除成功')
        fileArr.splice(index, 1)
        previewFileArr.value.splice(index, 1)
        // })
    }
}

function dataFormat(type) {
    const correctType = formData.value.correctType;
    console.log(type,activeName.value,correctType)
    switch (type) {
        case 'Ⅰ':
        case 'Ⅱ':
            return (['01','02', '03'].includes(correctType) && activeName.value == '02')
        case 'Ⅲ':
            return (['02', '03'].includes(correctType) && activeName.value == '02') || (['01'].includes(correctType) && ((activeName.value == '02' && gradeFlag.value==1) || (activeName.value == '03' && gradeFlag.value==2)))
        case 'Ⅳ':
            return (['02', '03'].includes(correctType) && activeName.value == '02') || (['01'].includes(correctType) && ((activeName.value == '02' && gradeFlag.value==1) || (activeName.value == '03' && gradeFlag.value==2)))
        case 'Ⅴ':
            return (['02'].includes(correctType) && activeName.value == '02') || (['03'].includes(correctType) && activeName.value == '03') || (['01'].includes(correctType) && activeName.value == '03' && gradeFlag.value==1)
        case 'Ⅵ':
            return (['02', '03'].includes(correctType) && activeName.value == '03') || (['01'].includes(correctType) && activeName.value == '03' && gradeFlag.value==1)
        default:
            return false;
    }
}

function transVoice() {
    if (aiStart.value) {
        return ElMessage.warning('独家算法，请稍等！');
    }
    if (voiceStatus.value == 1) {
        speech.pause()
        voiceStatus.value = 2
        return
    }
    if (voiceStatus.value == 2) {
        speech.resume()
        voiceStatus.value = 1
        return
    }
    if (Object.keys(resultInfo.value).length) {
        let text = ''
        const loading = ElLoading.service({
            lock: true,
            text: '语音即将播放！',
            background: 'rgba(255, 255, 255, 0.7)',
        })
        const keys = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ"];
        keys.forEach(key => {
            if (key in resultInfo.value && resultInfo.value[key].length) {
                resultInfo.value[key].forEach((item, index) => {
                    text += item.replace(/<br\/>/g, '。').replace(
                        /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu,
                        '')
                    if (key == 'Ⅵ') {
                        if (resultInfo.value.Ⅶ && resultInfo.value.Ⅶ.length >= resultInfo.value.Ⅵ
                            .length) {
                            text += resultInfo.value.Ⅶ[index].replace(/<br\/>/g, '。').replace(
                                /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu,
                                '')
                        }
                        if (resultInfo.value.Ⅷ && resultInfo.value.Ⅷ.length >= resultInfo.value.Ⅵ
                            .length) {
                            text += resultInfo.value.Ⅷ[index].replace(/<br\/>/g, '。').replace(
                                /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu,
                                '')
                        }
                    }
                })
            }
        })

        speech.speak({
            text: text,
            listeners: {
                onstart: () => {
                    loading.close()
                    voiceStatus.value = 1;
                },
                onend: () => {
                    voiceStatus.value = 4
                }
            }
        });
    }
}

function resultTabChange(val) {
    speech.cancel()
    voiceStatus.value = 0
}

function exportEvent() {
    if (aiStart.value) {
        return ElMessage.warning('独家算法，请稍等！');
    }
    // if (!correctImgShow.value && fileList.value.length) {
    //     return ElMessage.warning('图片批改中，请稍等！');
    // }
    const keys = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ"];
    let text = ''
    keys.forEach(key => {
        if (key in resultInfo.value && resultInfo.value[key].length) {
            resultInfo.value[key].forEach((item, index) => {
                text += `<div>${item}</div>`
                if (key == 'Ⅵ') {
                    if (resultInfo.value.Ⅶ && resultInfo.value.Ⅶ.length >= resultInfo.value.Ⅵ.length) {
                        text += `<div>${resultInfo.value.Ⅶ[index]}</div>`
                    }
                    if (resultInfo.value.Ⅷ && resultInfo.value.Ⅷ.length >= resultInfo.value.Ⅵ.length) {
                        text += `<div>${resultInfo.value.Ⅷ[index]}</div>`
                    }
                }
            })
        }
    })

    html2Pdf({
        content: text,
        picUrlList: compImg.value || []
    }).then(res => {
        console.log(res)
        let temp = document.createElement('a') // 创建a标签
        temp.download = '评阅结果.pdf'// 设置下载名称
        temp.href = res.data;

        // 手动触发点击事件
        temp.click()
    })
}

onBeforeUnmount(() => {
    controller && controller.abort()
    speech && speech.cancel()
})

onMounted(() => {
    formPage.value = route.query.page;
    speech.init({
        volume: 1,
        lang: 'zh-CN',
        rate: 1.4,
        pitch: 1.4,
    }).then(() => {
        console.log('语音引擎初始化成功');
    });

    const grade = sessionStorage.getItem("grade");
			const obj = gradeMap.find(item=>{
				return item.label == grade
			})
			gradeFlag.value=obj.type
})
</script>
<style lang="scss" scoped>
@import "@/style/variable.scss";
.correct-title {
    font-size: 12px;
    color: $base-text-color;
    line-height: 1.8;
    margin: 20px 0;
}

.correct-tip {
    font-size: 12px;
    margin: 10px 0;
    color: #999;
}

.upload-box {
     ::v-deep .el-upload-list--picture-card {
        --el-upload-list-picture-card-size: 120px;
    }
     ::v-deep .el-upload--picture-card {
        --el-upload-picture-card-size: 120px
    }
    .upload-inner {
        text-align: center;
        color: #ccc;
    }
}

.page-box-correct {
    position: relative;
     ::v-deep .el-tabs__item.is-active,
     ::v-deep .el-tabs__item:hover {
        color: $base-color;
    }
     ::v-deep .el-tabs__active-bar {
        background-color: $base-color;
    }
    .page-box-correct-btn {
        position: absolute;
        right: 0;
        top: 10px;
        display: flex;
        &>div {
            width: 80px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            background: $base-color;
            color: #fff;
            border-radius: 8px;
            font-size: 12px;
            cursor: pointer;
        }
        &>div+div {
            margin-left: 10px;
        }
    }
}

.history-file {
    display: flex;
    flex-wrap: wrap;
    margin: 10px 0;
    .history-file-item {
        border: 1px solid $base-border-color;
        width: 120px;
        height: 120px;
        border-radius: 10px;
        overflow: hidden;
        margin-right: 10px;
        margin-bottom: 10px;
    }
}

.history-tip {
    font-size: 12px;
    margin: 10px 0;
    color: #999;
}

.distinction-box {
    line-height: 1.6;
    .distinction-box-title {
        font-weight: bold;
        margin: 5px 0;
    }
}
</style>
